"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7373],{

/***/ 96605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14229);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63858);
/* eslint-disable no-param-reassign */ 
//  Utils

// constact


var isRefreshing = false;
var failedQueue = [];
var processQueue = function(error, token) {
    failedQueue.forEach(function(prom) {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};
/**
 * generateRefreshToken
 * hit API /login/refresh
 * destory old cookies
 * save response data to cookies
 * @param {string} refreshToken
 */ function generateRefreshToken(refreshToken, originalRequest) {
    if (isRefreshing) {
        return new Promise(function(resolve, reject) {
            failedQueue.push({
                resolve: resolve,
                reject: reject
            });
        }).then(function(token) {
            originalRequest.headers.Authorization = "Bearer ".concat(token);
            return axios__WEBPACK_IMPORTED_MODULE_0___default()(originalRequest);
        }).catch(function(err) {
            return Promise.reject(err);
        });
    }
    isRefreshing = true;
    return new Promise(function(resolve, reject) {
        axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/login/refresh"), null, {
            headers: {
                Authorization: "Bearer ".concat(refreshToken)
            }
        }).then(function(response) {
            if (!response || !response.data || response.data.error) {
                throw new Error("Could not refresh token");
            }
            var data = response.data.data;
            var accessUser = utils_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getUserAccess */ .Z.getUserAccess();
            // remove saved cookies
            utils_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"].destroyToken */ .Z.destroyToken();
            var parsedAccessExpired = new Date(data.access.expired_at).getTime() / 1000;
            var parsedRefreshExpired = new Date(data.refresh.expired_at).getTime() / 1000;
            // save userdata to credentials entities
            utils_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"].saveToken */ .Z.saveToken({
                accessToken: data.access.token,
                accessTokenExp: parsedAccessExpired,
                refreshToken: data.refresh.token,
                refreshTokenExp: parsedRefreshExpired,
                accessUser: accessUser
            });
            (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .dispatchSetErrorCode */ .S)(null);
            // change token in header
            originalRequest.headers.Authorization = "Bearer ".concat(data.access.token);
            processQueue(null, data.access.token);
            resolve(axios__WEBPACK_IMPORTED_MODULE_0___default()(originalRequest));
        }).catch(function(err) {
            // remove saved cookies
            if (window) {
                var ERROR_CODE = 401;
                (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .dispatchSetErrorCode */ .S)(ERROR_CODE);
            // auth.destroyToken();
            // router.push('/logout');
            }
            processQueue(err, null);
            reject(err);
        }).then(function() {
            isRefreshing = false;
        });
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (generateRefreshToken);


/***/ }),

/***/ 44493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14229);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25516);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61608);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86123);
/* harmony import */ var _generateRefreshToken__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96605);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63858);
/* eslint-disable no-else-return */ //  Utils

// alert error message

// refresh token
// constant




/**
 * handleDefault
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleDefault = function(errorType, message) {
    if (errorType === constants_errorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PAYWALL_NOSUBSCRIPTION */ .Z.PAYWALL_NOSUBSCRIPTION) return;
    if (errorType === constants_errorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].FORBIDDEN */ .Z.FORBIDDEN) return;
    var errMessageDefault = message;
    (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(errMessageDefault, constants_errorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
};
/**
 * handleMaintenance
 * web legacy: app\lib\Api.js line 184
 * @param {*} errorType | MAINTENANCE | ERROR_GATEWAY
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleMaintenance = function(errorType, message) {
    if (errorType === "MAINTENANCE" && message) {
        (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .dispatchSetErrorCode */ .S)(503, message);
    }
};
/**
 * handleNoPermission
 * web legacy: app\lib\Api.js line 187
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNoPermission = function() {
    (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(constants_errorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].PERMISSION_DENIED */ .Z.PERMISSION_DENIED, constants_errorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
};
/**
 * handleUnAuthorized
 * web legacy: app\lib\Api.js line 192
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleInvalidParameter = function(_, message) {
    (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(message, constants_errorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
};
/**
 * handleInvalidPIN
 * web legacy: app\lib\Api.js line 229
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleInvalidPIN = function() {
// TODO: handleInvalidPIN
};
/**
 * handleSystemError
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleSystemError = function(_, message) {
    (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(message, constants_errorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
};
/**
 * handleInternalServerError
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ // eslint-disable-next-line no-unused-vars
var handleInternalServerError = function(_, message) {
    (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .dispatchSetErrorCode */ .S)(500);
};
/**
 * handleNotFound
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotFound = function(_, message) {
    (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(message, constants_errorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
};
/**
 * handleNotSubscription
 * web legacy: app\lib\Api.js line 238
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleNotSubscription = function() {
// TODO: url
};
/**
 * handleUnAuthorized
 * web legacy: app\lib\Api.js line 255
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ // eslint-disable-next-line consistent-return
var handleUnAuthorized = function(originalRequest) {
    var ref;
    var parsedCookie = utils_auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getToken */ .Z.getToken();
    var refreshToken = parsedCookie === null || parsedCookie === void 0 ? void 0 : (ref = parsedCookie.refresh) === null || ref === void 0 ? void 0 : ref.token;
    var ERROR_CODE = 401;
    // hit API refresh token
    // set new token to cookies
    if (refreshToken) {
        return (0,_generateRefreshToken__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(refreshToken, originalRequest);
    } else if ((0,constants_app__WEBPACK_IMPORTED_MODULE_3__/* .isClient */ .C5)()) {
        (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .dispatchSetErrorCode */ .S)(ERROR_CODE);
    // router.push('/logout');
    }
// next step:
// TODO: logout user, getLocalRefresh,
// TODO: destroy cuurent crips session, clear
};
/**
 * handleLogoutTradingUser
 * web legacy: app\lib\Api.js line 271
 * INVALID_SESSION, ERR_LOGIN_AUTHORIZATION,
 * ERR_PIN_AUTHORIZATION, ERR_UNKNOWN_BROKER
 * @param {*} errorType | optional
 * @param {*} message | optional
 * @param {*} singleError  | optional
 */ var handleLogoutTradingUser = function() {
// TODO: call function logout trading user
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    handleDefault: handleDefault,
    handleMaintenance: handleMaintenance,
    handleNoPermission: handleNoPermission,
    handleInvalidParameter: handleInvalidParameter,
    handleInvalidPIN: handleInvalidPIN,
    handleSystemError: handleSystemError,
    handleNotFound: handleNotFound,
    handleNotSubscription: handleNotSubscription,
    handleUnAuthorized: handleUnAuthorized,
    handleLogoutTradingUser: handleLogoutTradingUser,
    handleInternalServerError: handleInternalServerError
});


/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61608);
/* harmony import */ var _handler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44493);
// handler function



// constact
var handleDefault = _handler__WEBPACK_IMPORTED_MODULE_1__/* ["default"].handleDefault */ .Z.handleDefault, handleMaintenance = _handler__WEBPACK_IMPORTED_MODULE_1__/* ["default"].handleMaintenance */ .Z.handleMaintenance, handleNoPermission = _handler__WEBPACK_IMPORTED_MODULE_1__/* ["default"].handleNoPermission */ .Z.handleNoPermission, handleInvalidParameter = _handler__WEBPACK_IMPORTED_MODULE_1__/* ["default"].handleInvalidParameter */ .Z.handleInvalidParameter, handleInvalidPIN = _handler__WEBPACK_IMPORTED_MODULE_1__/* ["default"].handleInvalidPIN */ .Z.handleInvalidPIN, handleSystemError = _handler__WEBPACK_IMPORTED_MODULE_1__/* ["default"].handleSystemError */ .Z.handleSystemError, handleNotFound = _handler__WEBPACK_IMPORTED_MODULE_1__/* ["default"].handleNotFound */ .Z.handleNotFound, handleNotSubscription = _handler__WEBPACK_IMPORTED_MODULE_1__/* ["default"].handleNotSubscription */ .Z.handleNotSubscription, handleUnAuthorized = _handler__WEBPACK_IMPORTED_MODULE_1__/* ["default"].handleUnAuthorized */ .Z.handleUnAuthorized, handleLogoutTradingUser = _handler__WEBPACK_IMPORTED_MODULE_1__/* ["default"].handleLogoutTradingUser */ .Z.handleLogoutTradingUser, handleInternalServerError = _handler__WEBPACK_IMPORTED_MODULE_1__/* ["default"].handleInternalServerError */ .Z.handleInternalServerError;
var _obj;
/**
 * APIErrorMessage
 * object for grouping function error handle
 * add this object with your new function handler
 */ var APIErrorMessage = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DEFAULT */ .Z.DEFAULT, handleDefault), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].MAINTENANCE */ .Z.MAINTENANCE, handleMaintenance), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].NOPERMISSION */ .Z.NOPERMISSION, handleNoPermission), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].INVALIDPARAMETER */ .Z.INVALIDPARAMETER, handleInvalidParameter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].INVALID_PARAMETER */ .Z.INVALID_PARAMETER, handleInvalidParameter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].INVALID_LOGIN */ .Z.INVALID_LOGIN, handleInvalidParameter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ERR_SYSTEM */ .Z.ERR_SYSTEM, handleInvalidParameter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ERR_INVALID_PARAMS */ .Z.ERR_INVALID_PARAMS, handleInvalidParameter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ERR_ORDER_FAIL */ .Z.ERR_ORDER_FAIL, handleInvalidParameter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ERR_PIN_INVALID */ .Z.ERR_PIN_INVALID, handleInvalidParameter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ERR_LOGIN_FAIL */ .Z.ERR_LOGIN_FAIL, handleInvalidParameter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].INVALID_AMEND */ .Z.INVALID_AMEND, handleInvalidParameter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].INVALID_PIN */ .Z.INVALID_PIN, handleInvalidPIN), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SYSTEMERROR */ .Z.SYSTEMERROR, handleSystemError), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].NOTFOUND */ .Z.NOTFOUND, handleNotFound), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].NOSUBSCRIPTION */ .Z.NOSUBSCRIPTION, handleNotSubscription), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].UNAUTHORIZED */ .Z.UNAUTHORIZED, handleUnAuthorized), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].INVALID_SESSION */ .Z.INVALID_SESSION, handleLogoutTradingUser), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ERR_LOGIN_AUTHORIZATION */ .Z.ERR_LOGIN_AUTHORIZATION, handleLogoutTradingUser), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ERR_PIN_AUTHORIZATION */ .Z.ERR_PIN_AUTHORIZATION, handleLogoutTradingUser), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ERR_UNKNOWN_BROKER */ .Z.ERR_UNKNOWN_BROKER, handleLogoutTradingUser), _obj);
/**
 * APIErrorMessageHandler
 * call object APIErrorMessage based on error type
 * @param {string} errorType | required
 * @param {string} message | required
 * @param {string|object error} singleError | optional
 */ var APIErrorMessageHandler = function(errorType, message, singleError) {
    return (APIErrorMessage[errorType] || APIErrorMessage[constants_errorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DEFAULT */ .Z.DEFAULT])(errorType, message, singleError);
};
/**
 * Exodus API error message handler
 * @param {number} status - HTTP Response status | required
 * @param {string} errorType - Error types | required
 * @param {string} message - Error message | required
 */ var APIExodusErrorHandler = function(status, errorType, message) {
    var listErrorResponse = {
        DEFAULT: handleDefault,
        400: handleInvalidParameter,
        401: handleUnAuthorized,
        402: handleNotSubscription,
        403: handleDefault,
        404: handleNotFound,
        429: handleDefault,
        500: handleInternalServerError,
        502: handleDefault,
        503: handleMaintenance,
        504: handleDefault
    };
    var response = listErrorResponse[status] || listErrorResponse.DEFAULT;
    return response(errorType, message);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    APIErrorMessageHandler: APIErrorMessageHandler,
    APIExodusErrorHandler: APIExodusErrorHandler
});


/***/ }),

/***/ 63858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ dispatchSetErrorCode; }
/* harmony export */ });
/* harmony import */ var global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73580);
/* eslint-disable import/prefer-default-export */ 
var dispatchSetErrorCode = function(errorCode) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    global_MainLayout_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].setState */ .Z.setState({
        errorCode: errorCode,
        errorMessage: errorMessage
    });
};


/***/ }),

/***/ 97373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86123);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61608);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25516);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14229);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91635);
/* harmony import */ var _APIErrorMessage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70770);
/* harmony import */ var _APIErrorMessage_handler__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44493);
/* eslint-disable no-undef */ 




// constact



// handler





var APIExodusErrorHandler = _APIErrorMessage__WEBPACK_IMPORTED_MODULE_8__/* ["default"].APIExodusErrorHandler */ .Z.APIExodusErrorHandler;
function requestExodus() {
    var isShowAlertMessage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, customUserAgent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraHeaders = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var headers = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        Accept: "application/json"
    }, extraHeaders);
    if (customUserAgent) {
        headers = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, headers), {
            "User-Agent": constants_api__WEBPACK_IMPORTED_MODULE_2__/* .CUSTOM_USER_AGENT */ .GV
        });
    }
    // create new api instance
    var apiInstance = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
        baseURL: constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7,
        headers: headers
    });
    // intercept api request
    apiInstance.interceptors.request.use(// onFullfilled
    function(req) {
        var ref;
        var parsedCookie = utils_auth__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getToken */ .Z.getToken();
        var token = parsedCookie.accessToken.token;
        var isOnline = (0,constants_app__WEBPACK_IMPORTED_MODULE_3__/* .isClient */ .C5)() ? window === null || window === void 0 ? void 0 : (ref = window.navigator) === null || ref === void 0 ? void 0 : ref.onLine : true;
        if (!isOnline) {
            (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"].OFFLINE */ .Z.OFFLINE, constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
            return Promise.reject(constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"].OFFLINE */ .Z.OFFLINE);
        }
        // refresh token
        if (req.headers.Authorization) {
            req.headers = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, req.headers), {
                Authorization: req.headers.Authorization
            });
        } else if (req.url !== "/user/setting/password/reset" && token) {
            // request with header accessToken
            // add access token to Authorization
            req.headers = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, req.headers), {
                Authorization: "Bearer ".concat(token)
            });
        }
        return req;
    }, // onRejected
    function(error) {
        return Promise.reject(error);
    });
    // Intercept api response
    apiInstance.interceptors.response.use(function() {
        var _ref = // on fullfilled
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(response) {
            var _data, errorType, _message, message, status;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _data = response.data, errorType = _data.error_type, _message = _data.message, message = _message === void 0 ? constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"].DEFAULT_ERROR_MESSAGE */ .Z.DEFAULT_ERROR_MESSAGE : _message, status = response.status;
                        if (![
                            401
                        ].includes(status)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", _APIErrorMessage_handler__WEBPACK_IMPORTED_MODULE_9__/* ["default"].handleUnAuthorized */ .Z.handleUnAuthorized(response.config));
                    case 3:
                        // only there's an error and isShowAlertMessage = true
                        if (errorType && isShowAlertMessage) {
                            APIExodusErrorHandler(status, errorType, message);
                        }
                        return _ctx.abrupt("return", response);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }(), // on rejected
    function(error) {
        if (error.response) {
            var _response = error.response, status = _response.status, data = _response.data;
            // eslint-disable-next-line prefer-destructuring
            var message = data.message;
            var errorType = data.error_type;
            if ([
                401
            ].includes(status)) {
                var ret = _APIErrorMessage_handler__WEBPACK_IMPORTED_MODULE_9__/* ["default"].handleUnAuthorized */ .Z.handleUnAuthorized(error.config);
                return ret;
            }
            if (isShowAlertMessage) {
                var ref, ref1;
                // the real error message is unparsed in `message`
                if (!errorType) {
                    var parsedMessage = JSON.parse(data.message);
                    message = parsedMessage.message;
                    errorType = parsedMessage.error_type;
                }
                APIExodusErrorHandler(status, errorType, message);
                (0,utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .sentryLog */ .gB)({
                    scope: "server-layer",
                    level: "error",
                    httpStatusCode: status,
                    tags: [
                        {
                            title: "api-error-url",
                            value: error === null || error === void 0 ? void 0 : (ref = error.request) === null || ref === void 0 ? void 0 : ref.responseURL
                        },
                        {
                            title: "api-error-text",
                            value: error === null || error === void 0 ? void 0 : (ref1 = error.request) === null || ref1 === void 0 ? void 0 : ref1.responseText
                        }, 
                    ],
                    error: error
                });
            }
        }
        return Promise.reject(error);
    });
    return apiInstance;
}
/* harmony default export */ __webpack_exports__["Z"] = (requestExodus);


/***/ }),

/***/ 61608:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var ERROR_MESSAGE = {
    ALERT_RED: "alert-red",
    DEFAULT: "DEFAULT",
    MAINTENANCE: "MAINTENANCE",
    NOPERMISSION: "NOPERMISSION",
    NOTRADINGPERMISSION: "NOTRADINGPERMISSION",
    INVALIDPARAMETER: "INVALIDPARAMETER",
    INVALID_PARAMETER: "INVALID_PARAMETER",
    INVALID_LOGIN: "INVALID_LOGIN",
    ERR_SYSTEM: "ERR_SYSTEM",
    ERR_INVALID_PARAMS: "ERR_INVALID_PARAMS",
    ERR_ORDER_FAIL: "ERR_ORDER_FAIL",
    ERR_PIN_INVALID: "ERR_PIN_INVALID",
    ERR_LOGIN_FAIL: "ERR_LOGIN_FAIL",
    INVALID_AMEND: "INVALID_AMEND",
    INVALID_PIN: "INVALID_PIN",
    SYSTEMERROR: "SYSTEMERROR",
    NOTFOUND: "NOTFOUND",
    NOSUBSCRIPTION: "NOSUBSCRIPTION",
    PAYWALL_ERROR: "PAYWALL",
    PAYWALL_NOSUBSCRIPTION: "NO_SUBSCRIPTION",
    NOPHONEVERIFY: "NOPHONEVERIFY",
    UNAUTHORIZED: "UNAUTHORIZED",
    FORBIDDEN: "FORBIDDEN",
    SERVICE_BUSY: "SERVICE_BUSY",
    INVALID_SESSION: "INVALID_SESSION",
    ERR_LOGIN_AUTHORIZATION: "ERR_LOGIN_AUTHORIZATION",
    ERR_PIN_AUTHORIZATION: "ERR_PIN_AUTHORIZATION",
    ERR_UNKNOWN_BROKER: "ERR_UNKNOWN_BROKER",
    INCORRECT_PIN: "INCORRECT_PIN",
    INVALID_CREDS: "INVALID_CREDS",
    UNKNOWN_SYSTEM_ERROR: "Kondisi Internet Kamu Sedang Tidak Stabil.",
    OFFLINE: "Kondisi internet kamu sedang tidak stabil",
    DEFAULT_ERROR_MESSAGE: "Something is terribly wrong, please contact our administrator",
    PERMISSION_DENIED: "You do not have enough permission to access the resources",
    // error message upload avatar onboarding
    UPLOAD_FAILED: "Upload Failed",
    PLEASE_LOAD_IMAGE: "Please load an image",
    UPLOAD_IMAGE_TYPE_NOT_SUPPORTED: "Only image file (type: JPEG, JPG, PNG, and GIF) allowed",
    UPLOAD_DOCUMENT_TYPE_NOT_SUPPORTED: "Only document file (type: PDF, DOC, DOCX, PPT, PPTX, XLS and XLSX) allowed",
    MAX_FILE_SIZE: "Max File Size 2Mb",
    INVALID_AVATAR_EXTENSION: "Only image file (type: JPEG, JPG, and PNG) allowed",
    // stream error message
    DOCUMENT_IMAGE_NOT_ALLOWED: 'Image files (such as jpg, jpeg, png, gif) are not allowed to be uploaded from "Attach Document" input',
    MAX_UPLOAD_FILES: "Maximum of 1 file uploads allowed",
    STREAM_TEXT_REQUIRED: "Text is required in posts",
    STREAM_TARGET_PRICE_REQUIRED: "Target Price is required in posts",
    STREAM_ERROR_UPLOAD_FILE: "Upload file error",
    ACADEMY_ERROR_MESSAGE: "Failed to open Academy, Please reload this page",
    // Screener
    SCREENER_SPECIFY_RULES: "Please enter at least one screening rule",
    SCREENER_SPECIFY_RULES_VALUE: "Please enter a value on your screening rule",
    // Tipping
    TIPPING_MAX_AMOUNT_ERROR: "Jumlah Maksimal Tip Rp 10,000,000",
    // Fundachart
    MAX_METRICES_AND_SYMBOLS: "Harap pilih tidak lebih dari total 10 parameter (perusahaan/metrik) untuk bagan",
    // Chartbit
    LOAD_TEMPLATE: "Failed to load template",
    SAVE_TEMPLATE: "Failed to save template"
};
/* harmony default export */ __webpack_exports__["Z"] = (ERROR_MESSAGE);


/***/ }),

/***/ 73580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: null,
    errorMessage: "",
    errorType: ""
};
var mainLayoutStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (mainLayoutStore);


/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ setUserId; },
/* harmony export */   "Kp": function() { return /* binding */ sentrySetUser; },
/* harmony export */   "gB": function() { return /* binding */ sentryLog; }
/* harmony export */ });
/* unused harmony export noticeError */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14229);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42227);







var setUserId = function(userId) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger || !(logger === null || logger === void 0 ? void 0 : logger.setUserId)) return;
    if (userId !== null) logger === null || logger === void 0 ? void 0 : logger.setUserId(userId.toString());
};
var noticeError = function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
err, customAttr) {
    if (false) {}
    var logger = window === null || window === void 0 ? void 0 : window.NREUM;
    if (!logger) return;
    // Get User Id from localStorage
    var ref = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess() || {}, userId = ref.id;
    // Set New Relic User Id
    if (err) {
        setUserId(userId || null);
        var mappedCustomAttr;
        try {
            mappedCustomAttr = Object.keys(customAttr).reduce(function(a, key) {
                var newKey = key.startsWith("sb") ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 2) : "sb".concat((0,_general__WEBPACK_IMPORTED_MODULE_1__/* .capitalizer */ .r$)(key, 0));
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, a), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newKey, customAttr[key]));
            }, {});
        } catch (error) {
            mappedCustomAttr = customAttr;
        }
        logger.noticeError(err, mappedCustomAttr);
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (noticeError);
var sentryLog = function(options) {
    var error = options.error, scopeName = options.scope, level = options.level, username = options.username, httpStatusCode = options.httpStatusCode, tags = options.tags;
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .withScope */ .$e(function(scope) {
        scope.setTag("scope", scopeName);
        scope.setLevel(level);
        if (httpStatusCode) {
            scope.setTag("http-status-code", httpStatusCode);
        }
        if (Array.isArray(tags) && tags.length > 0) {
            tags.forEach(function(item) {
                scope.setTag(item.title, item.value);
            });
        }
        if (username) {
            scope.setUser({
                username: username
            });
        }
        if (typeof error === "string") {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureMessage */ .uT(error);
        }
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, Error)) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb(error);
        }
    });
};
var sentrySetUser = function(isLoggedIn) {
    if (!isLoggedIn) {
        return;
    }
    var userData = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess();
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .setUser */ .av({
        username: userData === null || userData === void 0 ? void 0 : userData.username,
        id: userData === null || userData === void 0 ? void 0 : userData.id
    });
};


/***/ })

}]);